(function() { window.GUID_da88357a_3fb2_47a7_a620_b3b58acef38f = { getGuid: function() { return "da88357a-3fb2-47a7-a620-b3b58acef38f"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-games",
                        callback: (accordion, e) => {
                            //accordion.SetContentSticky(accordion.$Content.find(".round__header"));
                            //const $allGameBodies = ($except: JQuery) => {
                            //    return accordion.$Content.find(".game__body").not($except);
                            //};
                            const isInPopup = accordion.$Content.closest("#popup-select-game-to-stream").length > 0;
                            if (!isInPopup) {
                                accordion.$Content.offon("click.toggleGame", ".game__header", (e) => {
                                    const $target = $(e.target);
                                    if (!$target.closest(".is-streaming-button").length) {
                                        const $gameHeader = $(e.currentTarget);
                                        const $game = $gameHeader.closest(".game");
                                        //const $gameBody = $game.find(".game__body");
                                        //if ($gameBody.is(":visible")) {
                                        //    $gameBody.slideUp();
                                        //} else {
                                        //    $allGameBodies($gameBody).slideUp();
                                        //    if ($gameBody.length) {
                                        //        $gameBody.slideDown();
                                        //        //$gameBody.css({ display: "flex" });
                                        //    }
                                        //}
                                        const data = $game.data("html");
                                        if (data.url) {
                                            CS.Controls.Popup.ShowAjaxModal(data.url, null, ({ popup, isPopup }) => {
                                                if (!isPopup) {
                                                    return;
                                                }
                                                console.log("GameOptionsPopup");
                                                popup.$Control.offon("click.gameIsStreaming", ".is-streaming-button, .has-videos-button", (e) => {
                                                    CS.Views.MasterPage.ScrollToSection($(".accordion-videostreams"));
                                                    popup.Close();
                                                });
                                                popup.$Control.offon("click.streamGame", ".button-stream-game, .button-add-video-game", (e) => {
                                                    CS.Stream.showStreamingPopup(data, $(e.target).hasClass(".button-add-video-game"));
                                                    popup.Close();
                                                });
                                            }, ({ popup }) => {
                                                // Popup closed
                                            }, true);
                                        }
                                    }
                                });
                            }
                            CS.Controls.Button.Events.Clicked({
                                selector: accordion.$Content,
                                childSelector: ".is-streaming-button",
                                callback: (button, e) => {
                                    CS.Views.MasterPage.ScrollToSection($(".accordion-videostreams"));
                                },
                            });
                            const $tabMenu = accordion.$Content.find(`#tabmenu-games-section-tab-menu-${accordion.ContentId}`);
                            function toggleGamesVisibility($activeTab) {
                                $activeTab.addClass("is-highlighted");
                                const $siblings = $activeTab.siblings();
                                $siblings.removeClass("is-highlighted");
                                const id = $activeTab.attr("id");
                                const $roundsContainer = $activeTab
                                    .closest(".accordion-games")
                                    .find(".rounds");
                                if ($roundsContainer.length) {
                                    if (id) {
                                        if (id === "my-games") {
                                            $roundsContainer.addClass("my-games");
                                        }
                                        else {
                                            $roundsContainer.removeClass("my-games");
                                        }
                                    }
                                    const $rounds = $roundsContainer.find(".round");
                                    $rounds.each((i, round) => {
                                        const $games = $(round).find(".game");
                                        const $visibleGames = $games.filter((i, game) => {
                                            return $(game).css("display") !== "none";
                                        });
                                        if ($visibleGames.length) {
                                            $(round).show();
                                        }
                                        else {
                                            $(round).hide();
                                        }
                                    });
                                }
                            }
                            if ($tabMenu.length) {
                                const $defaultTab = $tabMenu.find(".tab-menu-item.is-highlighted");
                                toggleGamesVisibility($defaultTab);
                                $tabMenu.offon("click.gamesSection", ".tab-menu-item", (e) => {
                                    const $item = $(e.currentTarget);
                                    toggleGamesVisibility($item);
                                });
                            }
                        },
                    });
                    CS.Controls.Accordion.Events.ContentLoaded({
                        selector: "body",
                        childSelector: ".accordion-games",
                        callback: (accordion, e) => { },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
